import { IJwtPayload } from "@types";
import moment from "moment";
import { decodeToken } from "react-jwt";
import { getToken } from "./storage";

const calculateTokenRefreshDelay = (
  bufferTimeInMinutes = 5
): number => {
  try {
    const tokenWebApp = getToken("WebApp");
    const { expireTime } = decodeToken(tokenWebApp) as IJwtPayload;

    if (!moment(expireTime).isValid()) {
      return 0;
    }

    const now = moment();
    const delayInMilliseconds =
      moment(expireTime).diff(now, "milliseconds") -
      bufferTimeInMinutes * 60 * 1000;

    return delayInMilliseconds;
  } catch {
    return 0;
  }
};

export { calculateTokenRefreshDelay };

